import { StructuredStorageSlots } from '../../constants';
import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class CreateIteratorStructuredStorageHelper extends StructuredStorageBaseHelper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.unwrapVal({ type: this.type }));
        sb.emitPushInt(node, StructuredStorageSlots.prefix);
        sb.emitOp(node, 'PICKITEM');
        sb.emitHelper(node, options, sb.helpers.iterStorage);
    }
}

//# sourceMappingURL=CreateIteratorStructuredStorageHelper.js.map
